let entity = "XmlTransfer"
export const GET_ALL =  `${process.env.REACT_APP_URL}${entity}`
export const PUT_RETRANFER =  `${process.env.REACT_APP_URL}${entity}`